import { useEffect, useState } from "react";
import { useStore } from "react-redux";

// helpers
import * as helper from "./helper";

// components
import { Button } from "shared/components/bulma/button";
import { RecommendationItem } from "./recommendation-item";
import { QuickView } from "shared/components/bulma/quick-view";

import { setRecommendation as setCustomerRecommendation }
    from "hyc-store/reducers/customers/customer-recommendation";

const CustomerRecommendations = ({ customer }) => {

    const store = useStore();

    const [recommendation, setRecommendation] = useState(null);

    const QuickViewButton = ({ onClick }) => (
        <Button onClick={onClick} className="is-primary is-light is-afloat-right mb-6">
            <span className="icon-text">
                <span className="icon">
                    <i className="fas fa-robot"></i>
                </span>
                <span className="pr-3">Enrico</span>
            </span >
        </Button>
    );

    useEffect(() => {
        const getData = async () => {
            const d = await helper.getRecommendation({ customer });
            store.dispatch(setCustomerRecommendation(d));
            setRecommendation(d);
        }

        if (customer?.id) {
            getData();
        }
    }, [customer, store]);

    if (!recommendation) {
        return null;
    }

    return (
        <QuickView title="Recommendations" QuickViewButton={QuickViewButton}>
            <div className="container mt-4 py-4 px-6">
                {helper.categories.map((category, index) => {

                    if (!recommendation[category]) {
                        return null;
                    }

                    return (
                        <RecommendationItem
                            key={`${category}-${index}`}
                            category={category} data={recommendation[category]} />
                    );
                })}
            </div>
        </QuickView>
    );
}


export { CustomerRecommendations };
